import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig
} from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule, routedComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { InboundPatientHomeComponent } from './components/inbound-patient/inbound-patient-home/inbound-patient-home.component';

import { SafeIframeSrcPipe } from './pipes/safe-iframe-src.pipe';

import { CommonUIComponent } from './components/common-ui/common-ui.component';

import { LoginComponent } from './components/login/login.component';
import { ConfirmCodeComponent } from './components/login/confirm-code/confirm-code.component';
import { NewPasswordRequiredComponent } from './components/login/new-password-required/new-password-required.component';

import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ForgotPasswordConfirmComponent } from './components/forgot-password/forgot-password-confirm.component';

import { ForgotUsernameComponent } from './components/forgot-username/forgot-username.component';

import { OrganizationTypeaheadComponent } from './components/widgets/organization-typeahead.component';
import { ErrorMessageComponent } from './components/widgets/error-message.component';

import { LogoutSuccessComponent } from './components/logout/logout-success.component';
import { LogoutConfirmComponent } from './components/logout/logout-confirm.component';
import { ForgotUsernameSuccessComponent } from './components/forgot-username/forgot-username-success.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormInputFieldComponent } from './components/widgets/form-input-field.component';
import { SessionExpireDialogComponent } from './components/dialogs/session-expire-dialog.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NewsComponent } from './components/news/news.component';
import { MatchHeightWidthDirective } from './directives/match-height-width.directive';
import { CalcEllipsisSizeDirective } from './directives/calc-ellipsis-size.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { UserListComponent } from './components/admin/user-list/user-list.component';
import { UserDetailsComponent } from './components/admin/user-details/user-details.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { ToasterComponent } from './components/toaster/toaster.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { PasswordExpiredComponent } from './components/login/password-expired/password-expired.component';
import { AdminUser } from './types/admin/admin-user';
import { BulkLoadDialogComponent } from './components/admin/bulk-load-dialog/bulk-load-dialog.component';
import { ErrorsDialogComponent } from './components/errors-dialog/errors-dialog.component';
import { LogoutComponent } from './components/logout/logout.component';
import { MfaSelfRegistrationComponent } from './components/login/mfa-self-registration/mfa-self-registration.component';
import { BannerComponent } from './components/banner/banner.component';
import { OverlayHomeComponent } from './components/overlay/overlay-home/overlay-home.component';
import { SetHeightDirective } from './directives/set-height.directive';
import { NetPromoterScoreComponent } from './components/npscore/net-promoter-score.component';
import {PrivacyNoticeComponent} from './components/privacy/user-privacy-notice.component';
import { AuditReportComponent } from './components/auditreport/audit-report.component';

@NgModule({
  declarations: [
    AppComponent,
    routedComponents,
    LoginComponent,
    CommonUIComponent,
    SafeIframeSrcPipe,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    ForgotUsernameSuccessComponent,
    OrganizationTypeaheadComponent,
    ErrorMessageComponent,
    ConfirmCodeComponent,
    NewPasswordRequiredComponent,
    ForgotPasswordConfirmComponent,
    LogoutSuccessComponent,
    LogoutConfirmComponent,
    FormInputFieldComponent,
    SpinnerComponent,
    SessionExpireDialogComponent,
    BulkLoadDialogComponent,
    ChangePasswordComponent,
    NewsComponent,
    MatchHeightWidthDirective,
    CalcEllipsisSizeDirective,
    SafeHtmlPipe,
    UserListComponent,
    UserDetailsComponent,
    AdminHomeComponent,
    ToasterComponent,
    ConfirmDialogComponent,
    PasswordExpiredComponent,
    ErrorsDialogComponent,
    LogoutComponent,
    MfaSelfRegistrationComponent,
    BannerComponent,
    OverlayHomeComponent,
    InboundPatientHomeComponent,
    SetHeightDirective,
    NetPromoterScoreComponent,
    PrivacyNoticeComponent,
    AuditReportComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot()
  ],
  entryComponents: [
    SessionExpireDialogComponent,
    BulkLoadDialogComponent,
    ChangePasswordComponent,
    ConfirmDialogComponent,
    ErrorsDialogComponent,
    PrivacyNoticeComponent
  ],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
